import { render, staticRenderFns } from "./add-subcategories.vue?vue&type=template&id=a5fee20e&scoped=true"
import script from "./add-subcategories.vue?vue&type=script&lang=js"
export * from "./add-subcategories.vue?vue&type=script&lang=js"
import style0 from "./add-subcategories.vue?vue&type=style&index=0&id=a5fee20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fee20e",
  null
  
)

export default component.exports